import React from 'react';

interface LoadingFallbackProps {
  message?: string;
}

export const LoadingFallback: React.FC<LoadingFallbackProps> = ({ message = 'Carregando módulo...' }) => (
  <div className="flex flex-col items-center justify-center p-8 w-full min-h-[160px] animate-fade-in">
    <div className="relative flex items-center justify-center mb-3">
      <div className="w-10 h-10 border-4 border-slate-200 border-t-[#1D3557] rounded-full animate-spin" />
      <div className="absolute w-5 h-5 bg-[#E63946] rounded-full animate-ping opacity-25" />
    </div>
    <span className="text-xs font-bold text-[#1D3557] tracking-wider uppercase">{message}</span>
  </div>
);

export const SkeletonCard: React.FC = () => (
  <div className="bg-white rounded-2xl p-5 border border-slate-200/80 shadow-2xs space-y-4 animate-pulse">
    <div className="flex justify-between items-center">
      <div className="h-4 bg-slate-200 rounded-md w-1/3" />
      <div className="h-5 bg-slate-200 rounded-full w-16" />
    </div>
    <div className="h-28 bg-slate-100 rounded-xl w-full" />
    <div className="space-y-2">
      <div className="h-3 bg-slate-200 rounded-md w-3/4" />
      <div className="h-3 bg-slate-200 rounded-md w-1/2" />
    </div>
  </div>
);

export default LoadingFallback;
